<template>
  <b-modal
      v-model="active"
      centered
      hide-footer
      :title="title"
      size="md"
  >
    <h2>
      {{email.title}}
    </h2>
    <h3>
      {{email.object}}
    </h3>
    <div style=" height: 80% ;overflow: scroll">
      <div
          v-html="email.text"
      ></div>
    </div>
  </b-modal>

</template>

<script>
export default {
  name: "email-visualizer",

  props : {
    email : {
      type : Object,
      required : true
    },
    title :{
      type : String,
      default : "Email sélectionné"
    }
  },

  data(){
    return{
      active : false
    }
  },

  methods : {
    managePopupOpen() {
      this.active = !this.active ;
    }
  }
}
</script>

<style scoped>
</style>